import { SwiperSlide } from "swiper/react";

import Img from "components/atoms/Img";
import Link from "components/atoms/LinkRouter";
import Title from "components/atoms/Title";
import PostSlider from "components/organisms/PostSlider";

const ServiceCard = ({ data, ...props }) => {
  return (
    <div className={props.className}>
      <Link className="block h-full" href={data?.link}>
        <div
          className="shadow-[0px_0px _20px_rgba(124,120,120,0.2)] flex h-full w-full flex-col justify-between rounded bg-bbc-gradient-service p-6 lg:rounded-xl"
          style={{ minHeight: "260px" }}
        >
          <Img
            className="mx-auto"
            wrapper={{ className: "w-full relative" }}
            {...data?.image}
          />
          <Title
            text={data?.title}
            as="h3"
            className={`text-lg font-semibold text-bbc-brand-700 ${
              data?.description ? "mb-6" : ""
            }`}
          />
          {data?.description && (
            <p className="text-black">{data.description}</p>
          )}
        </div>
      </Link>
    </div>
  );
};

const SerivceSlider = ({ listContent }) => {
  return (
    <PostSlider>
      {Array.isArray(listContent) &&
        listContent.length > 0 &&
        listContent.map((item, itemIdx) => (
          <SwiperSlide key={itemIdx} className="col-4 h-auto">
            <ServiceCard data={item} />
          </SwiperSlide>
        ))}
    </PostSlider>
  );
};

const Component = ({ title, subTitle, description, dataList }) => {
  return (
    <div className="container relative z-10 text-center">
      <Title
        text={title}
        className="title-h2 mb-6 px-7 text-bbc-30px text-bbc-brand-700"
      />
      {subTitle && (
        <Title
          text={subTitle}
          className="title-h2 mb-2 text-bbc-30px text-bbc-brand-700 lg:mb-10 lg:text-4xl lg:leading-[50px]"
        />
      )}
      {description && <p className="mb-10 lg:mb-8">{description}</p>}
      <div className="hidden lg:block">
        <div className="col-10 mx-auto">
          <div className="row gap-y-10">
            {dataList &&
              dataList.length > 0 &&
              dataList.map((item, itemIdx) => (
                <ServiceCard key={itemIdx} data={item} className="lg:col-4" />
              ))}
          </div>
        </div>
      </div>
      <div className="lg:hidden">
        <SerivceSlider listContent={dataList} />
      </div>
    </div>
  );
};

export default Component;
